import { groupOperations } from "@rshbintech.dboul/http";
import { logger } from "@rshbintech.dboul/logger";
import { ErrorWithStatus, RequestFileParams } from "./types";
import { POLLING_SESSION_STORAGE_KEY } from "./constants";

export const requestFile = async ({
  isMassPrintAction,
  requestId,
  clearTimer,
}: RequestFileParams) => {
  try {
    const response = isMassPrintAction
      ? await groupOperations.api.massPrintGet({
          exportId: requestId,
        })
      : await groupOperations.api.massExportGet({
          exportId: requestId,
        });

    if (response.ok) {
      const blob = await response.blob();

      const link = document.createElement("a");

      const date = new Date().toLocaleString();

      link.href = URL.createObjectURL(blob);

      link.download = isMassPrintAction
        ? `OwnBusiness ${date}.pdf`
        : `Export ${date}.xlsx`;

      link.click();
      URL.revokeObjectURL(link.href);

      clearTimer();
      sessionStorage.removeItem(POLLING_SESSION_STORAGE_KEY);
    }
  } catch (error) {
    const errorWithStatus = error as ErrorWithStatus;

    if (errorWithStatus.status && errorWithStatus.status !== 423) {
      logger.sendError(error);
      clearTimer();
    }
  }
};
